export const DEFAULT_TALENT_CARD_SORT = {
  sortBy: 'created_at',
  sortOrder: 'DESC',
};

export const HISTORY_TALENT_CARD_SORT = {
  sortBy: 'status_updated_at',
  sortOrder: 'DESC',
};

export function getDefaultTalentCardSort(usesHistoryEndpoint) {
  return usesHistoryEndpoint ? HISTORY_TALENT_CARD_SORT : DEFAULT_TALENT_CARD_SORT;
}

export function getEffectiveTalentCardSort(sortBy, sortOrder, defaultSort = DEFAULT_TALENT_CARD_SORT) {
  if (!sortBy) return defaultSort;
  return {
    sortBy,
    sortOrder: sortOrder === 'DESC' ? 'DESC' : 'ASC',
  };
}

export function getNextSortOrder(sortOrder) {
  return sortOrder === 'DESC' ? 'ASC' : 'DESC';
}

export function scheduleResultsScrollToStart(element, schedule = requestAnimationFrame) {
  schedule(() => {
    element?.scrollIntoView({ behavior: 'auto', block: 'start' });
  });
}
